import type { QueryClient } from '@tanstack/react-query';

import {
  COURSE_DESKTOPS_QUERY_KEY,
  COURSE_FOR_EDIT_QUERY_KEY,
  COURSE_JOIN_CODE_QUERY_KEY,
  COURSE_PARTICIPANTS_QUERY_KEY,
  COURSE_QUERY_KEY,
  COURSES_QUERY_KEY,
  FRESH_START_DESKTOP_QUERY_KEY,
  MY_DESKTOP_QUERY_KEY,
  TRAINER_DESKTOP_QUERY_KEY
} from './courses-query-keys';

const COURSE_KEY_PREFIXES = new Set([
  COURSES_QUERY_KEY,
  COURSE_QUERY_KEY,
  COURSE_DESKTOPS_QUERY_KEY,
  COURSE_PARTICIPANTS_QUERY_KEY,
  COURSE_FOR_EDIT_QUERY_KEY,
  COURSE_JOIN_CODE_QUERY_KEY,
  MY_DESKTOP_QUERY_KEY,
  TRAINER_DESKTOP_QUERY_KEY,
  FRESH_START_DESKTOP_QUERY_KEY
]);

export const clearAllCoursesQueries = (queryClient: QueryClient): void => {
  queryClient.removeQueries({
    predicate: query =>
      typeof query.queryKey[0] === 'string' && COURSE_KEY_PREFIXES.has(query.queryKey[0])
  });
};
